import {IUserResource} from "../../core/services/UserService";
import * as _ from "lodash";
import * as swal from 'sweetalert';
export class UserManagementPageComponent implements ng.IComponentOptions {
  public controller: any = UserManagementController;
  public template: string =
      `<h2>User Management <span class="subtitle">- {{$ctrl.title[$ctrl.type]}}</span><button ng-show="$ctrl.type === 'internal'" class="btn btn-primary pull-right" ng-click="$ctrl.addUser()">ADD NEW</button></h2>
          <div class="row padding-top" ng-show="$ctrl.type === 'internal'">
            <div class="col-sm-12">
            <div class="row">
            <div class="col-sm-8">
              <div class="input-group">
                <input type="text" class="form-control" placeholder="Search" ng-model="searchText.internal.$"/>
                <span class="input-group-btn">
                  <button class="btn btn-default">
                    <i class="fa fa-fw fa-search"></i>
                  </button>
                </span>
              </div>
            </div>
            <div class="col-sm-4">
              <ui-select ng-model="searchText.internal.state" name="status" required>
                <ui-select-match placeholder="Choose State">
                  <span ng-bind="$select.selected.name"></span>
                </ui-select-match>
                <ui-select-choices repeat="item.type as item in ($ctrl.states | filter: $select.search)">
                  <span ng-bind="item.name"></span>
                </ui-select-choices>
              </ui-select>
            </div>
          </div>
          <table class="table table-striped table-hover" ng-init="searchText.internal.state = '!inactive'">
            <thead>
              <tr>
                <th><input type="checkbox" ng-model="$ctrl.selectedAll.internal" ng-change="$ctrl.selectAllInternal(searchText.internal, $ctrl.selectedAll.internal)" /></th>
                <th>Name<i class="fa fa-fw fa-sort" ng-click="$ctrl.sortBy('internal','fullname')"></i></th>
                <th>Email<i class="fa fa-fw fa-sort" ng-click="$ctrl.sortBy('internal','email')"></i></th>
                <th>Ministry<i class="fa fa-fw fa-sort" ng-click="$ctrl.sortBy('internal','ministry.display_name')"></i></th>
                <th>Agency<i class="fa fa-fw fa-sort" ng-click="$ctrl.sortBy('internal','agency.display_name')"></i></th>
                <th>Status<i class="fa fa-fw fa-sort" ng-click="$ctrl.sortBy('internal','state')"></i></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr ng-repeat="user in $ctrl.users | filter: searchText.internal | orderBy: $ctrl.sortType.internal : $ctrl.reverse.internal">
                <td><input type="checkbox" ng-model="user.selected" /></td>
                <td>{{user.fullname}}</td>
                <td>{{user.email}}</td>
                <td>{{user.ministry.display_name}}</td>
                <td>{{user.agency.display_name}}</td>
                <td>{{user.state}}</td>
                <td><i class="fa fa-fw fa-tasks btn-icon" uib-tooltip="View Activity Stream" ng-click="$ctrl.viewActivity(user._id)"></i><i class="fa fa-fw fa-pencil btn-icon" uib-tooltip="Edit User" ng-click="$ctrl.editUser(user)"></i></td>
              </tr>
            </tbody>
          </table>
          <div class="row padding-bottom">
            <div class="col-sm-12">
              <button class="btn btn-default" type="button" ng-click="$ctrl.activateInternal(true)">ACTIVATE</button>
              <button class="btn btn-default" type="button" ng-click="$ctrl.activateInternal(false)">DEACTIVATE</button>
            </div>
          </div>
          </div>
          </div>
          <div ng-show="$ctrl.type === 'external_org'">
          <div class="row">
            <div class="col-md-12">
            <h4>
              <span class="label label-primary">Pending Approval</span>
            </h4>
            <table class="table table-striped table-hover">
              <thead>
                <tr>
                  <th><input type="checkbox" ng-model="$ctrl.selectedAll.external_org_pending" ng-change="$ctrl.selectAllExternalOrgPending($ctrl.selectedAll.external_org_pending)" /></th>
                  <th>Name<i class="fa fa-fw fa-sort" ng-click="$ctrl.sortBy('internal','name')"></i></th>
                  <th>Email<i class="fa fa-fw fa-sort" ng-click="$ctrl.sortBy('internal','ministry.display_name')"></i></th>
                  <th>Organisation<i class="fa fa-fw fa-sort" ng-click="$ctrl.sortBy('internal','agency.display_name')"></i></th>
                  <th>Organisation Type<i class="fa fa-fw fa-sort" ng-click="$ctrl.sortBy('internal','agency.display_name')"></i></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr ng-repeat="user in $ctrl.exOrgPendingUsers | orderBy: $ctrl.sortType.external_org_pending : $ctrl.reverse.external_org_pending">
                  <td><input type="checkbox" ng-model="user.selected" /></td>
                  <td>{{user.fullname}}</td>
                  <td>{{user.email}}</td>
                  <td>{{user.organization.name}}</td>
                  <td>{{user.organization.org_type}}</td>
                  <td><i class="fa fa-fw fa-list-alt btn-icon" ng-click="$ctrl.viewUser(user)" uib-tooltip="View Details"></i></td>
                </tr>
              </tbody>
            </table>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <button class="btn btn-default" type="button" ng-click="$ctrl.approveUser()">APPROVE</button>
              <button class="btn btn-default" type="button" ng-click="$ctrl.rejectUser()">REJECT</button>
            </div>
          </div>
          <hr/>
          <div class="row">
            <div class="col-md-12">
            <h4>
              <span class="label label-success">Approved</span>
            </h4>
            <div class="row">
              <div class="col-sm-8">
                <div class="input-group">
                  <input type="text" class="form-control" placeholder="Search" ng-model="searchText.external_org.$"/>
                  <span class="input-group-btn">
                    <button class="btn btn-default">
                      <i class="fa fa-fw fa-search"></i>
                    </button>
                  </span>
                </div>
              </div>
              <div class="col-sm-4">
                <ui-select ng-model="searchText.external_org.state" name="status" required>
                  <ui-select-match placeholder="Choose State">
                    <span ng-bind="$select.selected.name"></span>
                  </ui-select-match>
                  <ui-select-choices repeat="item.type as item in ($ctrl.states | filter: $select.search)">
                    <span ng-bind="item.name"></span>
                  </ui-select-choices>
                </ui-select>
              </div>
            </div>
            <table class="table table-striped table-hover" ng-init="searchText.external_org.state='!inactive'">
              <thead>
                <tr>
                  <th><input type="checkbox" ng-model="$ctrl.selectedAll.external_org" ng-change="$ctrl.selectAllExternalOrg(searchText.external_org, $ctrl.selectedAll.external_org)" /></th>
                  <th>Name<i class="fa fa-fw fa-sort" ng-click="$ctrl.sortBy('external_org','name')"></i></th>
                  <th>Email<i class="fa fa-fw fa-sort" ng-click="$ctrl.sortBy('external_org','ministry.display_name')"></i></th>
                  <th>Organisation<i class="fa fa-fw fa-sort" ng-click="$ctrl.sortBy('external_org','agency.display_name')"></i></th>
                  <th>Organisation Type<i class="fa fa-fw fa-sort" ng-click="$ctrl.sortBy('external_org','agency.display_name')"></i></th>
                  <th>Status<i class="fa fa-fw fa-sort" ng-click="$ctrl.sortBy('external_org','createdOn')"></i></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr ng-repeat="user in $ctrl.exOrgUsers | filter: searchText.external_org | orderBy: $ctrl.sortType.external_org : $ctrl.reverse.external_org">
                  <td><input type="checkbox" ng-model="user.selected" /></td>
                  <td>{{user.fullname}}</td>
                  <td>{{user.email}}</td>
                  <td>{{user.organization.name}}</td>
                  <td>{{user.organization.org_type}}</td>
                  <td>{{user.state}}</td>
                  <td><i class="fa fa-fw fa-tasks btn-icon" uib-tooltip="View Activity Stream" ng-click="$ctrl.viewActivity(user._id)"></i><i class="fa fa-fw fa-list-alt btn-icon" uib-tooltip="View Details" ng-click="$ctrl.viewUser(user)"></i></td>
                </tr>
              </tbody>
            </table>
            </div>
          </div>
          <div class="row padding-bottom">
            <div class="col-md-12">
              <button class="btn btn-default" type="button" ng-click="$ctrl.activateExOrg(true)">ACTIVATE</button>
              <button class="btn btn-default" type="button" ng-click="$ctrl.activateExOrg(false)">DEACTIVATE</button>
            </div>
          </div>
          <label class="control-label">
            <input type="checkbox" ng-model="$ctrl.showReject"/> Show Rejected Users
          </label>
          <hr ng-show="$ctrl.showReject"/>
          <div class="row" ng-show="$ctrl.showReject">
            <div class="col-sm-12">
            <h4>
              <span class="label label-danger">Rejected</span>
            </h4>
            <table class="table table-striped table-hover" ng-init="searchText.external_org_reject.state='!inactive'">
              <thead>
                <tr>
                  <th><input type="checkbox" ng-model="$ctrl.selectedAll.external_org_reject" ng-change="$ctrl.selectAllExternalOrgReject($ctrl.selectedAll.external_org_reject)" /></th>
                  <th>Name<i class="fa fa-fw fa-sort" ng-click="$ctrl.sortBy('external_org_reject','name')"></i></th>
                  <th>Email<i class="fa fa-fw fa-sort" ng-click="$ctrl.sortBy('external_org_reject','ministry.display_name')"></i></th>
                  <th>Organisation<i class="fa fa-fw fa-sort" ng-click="$ctrl.sortBy('external_org_reject','agency.display_name')"></i></th>
                  <th>Organisation Type<i class="fa fa-fw fa-sort" ng-click="$ctrl.sortBy('external_org_reject','agency.display_name')"></i></th>
                  <th>Status<i class="fa fa-fw fa-sort" ng-click="$ctrl.sortBy('external_org_reject','createdOn')"></i></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr ng-repeat="user in $ctrl.exOrgRejectUsers | filter: searchText.external_org_reject | orderBy: $ctrl.sortType.external_org_reject : $ctrl.reverse.external_org_reject">
                  <td><input type="checkbox" ng-model="user.selected" /></td>
                  <td>{{user.fullname}}</td>
                  <td>{{user.email}}</td>
                  <td>{{user.organization.name}}</td>
                  <td>{{user.organization.org_type}}</td>
                  <td>{{user.state}}</td>
                  <td><i class="fa fa-fw fa-list-alt btn-icon" uib-tooltip="View Details" ng-click="$ctrl.viewUser(user)"></i></td>
                </tr>
              </tbody>
            </table>
            </div>
            <div class="col-sm-12 padding-bottom">
              <button class="btn btn-default" type="button" ng-click="$ctrl.revoke()">Reverse Rejection</button>
            </div>
          </div>
        </div>
        <div ng-show="$ctrl.type == 'external'">
        <div class="row padding-top">
          <div class="col-md-8">
            <div class="input-group">
              <input type="text" class="form-control" placeholder="Search" ng-model="searchText.external.$"/>
              <span class="input-group-btn">
                <button class="btn btn-default">
                  <i class="fa fa-fw fa-search"></i>
                </button>
              </span>
            </div>
          </div>
          <div class="col-sm-4">
            <ui-select ng-model="searchText.external.state" name="status" required>
              <ui-select-match placeholder="Choose State">
                <span ng-bind="$select.selected.name"></span>
              </ui-select-match>
              <ui-select-choices repeat="item.type as item in ($ctrl.states | filter: $select.search)">
                <span ng-bind="item.name"></span>
              </ui-select-choices>
            </ui-select>
          </div>
        </div>
        <table class="table table-striped table-hover" ng-init="searchText.external.state='!inactive'">
          <thead>
            <tr>
              <th><input type="checkbox" ng-model="$ctrl.selectedAll.external" ng-change="$ctrl.selectAllExternal(searchText.external, $ctrl.selectedAll.external)" /></th>
              <th>Name<i class="fa fa-fw fa-sort" ng-click="$ctrl.sortBy('external','fullname')"></i></th>
              <th>Email<i class="fa fa-fw fa-sort" ng-click="$ctrl.sortBy('external','email')"></i></th>
              <th>User Type<i class="fa fa-fw fa-sort" ng-click="$ctrl.sortBy('external','category')"></i></th>
              <th>Status<i class="fa fa-fw fa-sort" ng-click="$ctrl.sortBy('external','state')"></i></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr ng-repeat="user in $ctrl.exUsers | filter: searchText.external | orderBy: $ctrl.sortType.external : $ctrl.reverse.external">
              <td><input type="checkbox" ng-model="user.selected" /></td>
              <td>{{user.fullname}}</td>
              <td>{{user.email}}</td>
              <td>{{user.category}}</td>
              <td>{{user.state}}</td>
              <td><i class="fa fa-fw fa-tasks btn-icon" uib-tooltip="View Activity Stream" ng-click="$ctrl.viewActivity(user._id)"></i><i class="fa fa-fw fa-list-alt btn-icon" uib-tooltip="View Details" ng-click="$ctrl.viewUser(user)"></i></td>
            </tr>
          </tbody>
        </table>
        <div class="row padding-bottom">
          <div class="col-md-12">
            <button class="btn btn-default" type="button" ng-click="$ctrl.activateExternal(true)">ACTIVATE</button>
            <button class="btn btn-default" type="button" ng-click="$ctrl.activateExternal(false)">DEACTIVATE</button>
          </div>
        </div>
        </div>`;
}

export class UserManagementController {
  public static $inject: Array<string> = ["$scope","$uibModal","UserService","$stateParams"];
  public users: Array<any>;
  public exOrgPendingUsers: Array<any>;
  public exOrgRejectUsers: Array<any>;
  public exOrgUsers: Array<any>;
  public exUsers: Array<any>;
  public selectedAll: any;
  public sortType: any;
  public reverse: any;
  public type: string;
  public title: any;
  public states: Array<any>;
  public showReject: boolean;
  constructor(private $scope: ng.IScope, private $uibModal: ng.ui.bootstrap.IModalService, private UserService: IUserResource, private $stateParams: ng.ui.IStateParamsService) {
    $scope.$emit("adminPageChange",{name:"user"});
    this.loadIntUser();
    this.loadExOrg();
    this.exUsers = UserService.query({type:"external", allFields: true});
    this.sortType = {internal: "createdOn", external_org: "createdOn", external: "createdOn", external_org_pending: "createdOn", external_org_reject: "createdOn"};
    this.reverse = {internal: true, external_org: true, external: true, external_org_pending: true, external_org_reject: true};
    this.type = $stateParams.type || "internal";
    this.title = {
      'internal': 'Data Provider (Ministry/Agency)',
      'external_org': 'Organisation (Public)',
      'external': 'Individual (Public)'
    }
    this.states = [
      {name: "Active", type: "!inactive"},
      {name: "Inactive", type: "inactive"},
      {name: "All Records", type: ""}
    ]
  }
  private loadExOrg() {
    let exOrgUsers = this.UserService.query({type:"external_org", allFields: true});
    exOrgUsers.$promise.then(() => {
      this.exOrgPendingUsers = _.filter(exOrgUsers, {state: "pending"});
      this.exOrgUsers = _.reject(exOrgUsers, {state: "pending"});
    })
    this.exOrgRejectUsers = this.UserService.query({type:"external_org", allFields: true, state: "reject"});
  }
  private loadIntUser() {
    this.users = this.UserService.query({type:"internal", allFields: true});
  }
  public addUser() {
    let modalInstance = this.$uibModal.open({
      component: "userModal"
    })
    modalInstance.result.then(user => {
      this.users.push(user);
    })
    .catch(() => {

    })
  }
  public editUser(user) {
    let modalInstance = this.$uibModal.open({
      component: 'userModal',
      resolve: {
        user: () => {
          return user;
        }
      }
    });
    modalInstance.result.then(user => {
      this.loadIntUser();
    })
    .catch(() => {

    })
  }
  public selectAllInternal(filter, state) {
    let _state = 'inactive'
    if (filter.state === '!inactive') {
      _state = 'active'
    }
    _.each(this.users, _user => {
      if (filter && filter.state && _user.state === _state) {
        _user.selected = state;
      }
    })
  }
  public selectAllExternalOrgPending(state) {
    _.each(this.exOrgPendingUsers, _user => {
      _user.selected = state;
    })
  }
  public selectAllExternalOrgReject(state) {
    _.each(this.exOrgRejectUsers, _user => {
      _user.selected = state;
    })
  }
  public selectAllExternalOrg(filter, state) {
    let _state = 'inactive'
    if (filter.state === '!inactive') {
      _state = 'active'
    }
    _.each(this.exOrgUsers, _user => {
      if (filter && filter.state && _user.state === _state) {
        _user.selected = state;
      }
    })
  }
  public selectAllExternal(filter, state) {
    let _state = 'inactive'
    if (filter.state === '!inactive') {
      _state = 'active'
    }
    _.each(this.exUsers, _user => {
      if (filter && filter.state && _user.state === _state) {
        _user.selected = state;
      }
    })
  }
  public activateInternal(active: boolean) {
    let _users = _.filter(this.users, {selected: true});
    if (_users.length) {
      let _names = _.reduce(_users, (res, user) => {
        return res + "<strong>" +  user.fullname + "</strong><br/>";
      },"");
      swal({
        type: "info",
        title: active?"Activate User":"Deactivate User",
        html: true,
        text: `Are you sure you want to ${active?"activate":"deactivate"} the following users<br/>${_names}`,
        showCancelButton: true
      }, (isConfirm) => {
        if (isConfirm) {
          _.each(_users, (_user) => {
            _user.state = active? "active": "inactive";
          });
          this.UserService.updateAll(_users).$promise.then(() => {
            this.users = this.UserService.query({type:"internal", allFields: true});
          })
        }
      })
    }
  }
  public activateExternal(active: boolean) {
    let _users = _.filter(this.exUsers, {selected: true});
    if (_users.length) {
      let _names = _.reduce(_users, (res, user) => {
        return res + "<strong>" +  user.fullname + "</strong><br/>";
      },"");
      swal({
        type: "info",
        title: active?"Activate User":"Deactivate User",
        html: true,
        text: `Are you sure you want to ${active?"activate":"deactivate"} the following users<br/>${_names}`,
        showCancelButton: true
      }, (isConfirm) => {
        if (isConfirm) {
          _.each(_users, (_user) => {
            _user.state = active? "active": "inactive";
          });
          this.UserService.updateAll(_users).$promise.then(() => {
            this.exUsers = this.UserService.query({type:"external", allFields: true});
          })
        }
      })
    }
  }
  public activateExOrg(active: boolean) {
    let _users = _.filter(this.exOrgUsers, {selected: true});
    if (_users.length) {
      let _names = _.reduce(_users, (res, user) => {
        return res + "<strong>" +  user.fullname + "</strong><br/>";
      },"");
      swal({
        type: "info",
        title: active?"Activate User":"Deactivate User",
        html: true,
        text: `Are you sure you want to ${active?"activate":"deactivate"} the following users<br/>${_names}`,
        showCancelButton: true
      }, (isConfirm) => {
        if (isConfirm) {
          _.each(_users, (_user) => {
            _user.state = active? "active": "inactive";
          });
          this.UserService.updateAll(_users).$promise.then(() => {
            this.users = this.UserService.query({type:"internal", allFields: true});
          })
        }
      })
    }
  }
  public approveUser() {
    let _users = _.filter(this.exOrgPendingUsers, {selected: true});
    if(_users.length) {
      let _names = _.reduce(_users, (res, user) => {
        return res + user.fullname + "<br/>";
      },"");
      swal({
        type: "warning",
        title: "Are you sure?",
        text: `You want to approve?<br/>${_names}`,
        html: true,
        showCancelButton: true
      }, () => {
        this.UserService.approve(_users).$promise.then((saved) => {
          this.loadExOrg();
        })
      })
    }
  }
  public rejectUser() {
    let _users = _.filter(this.exOrgPendingUsers, {selected: true});
    if (_users.length) {
      let _names = _.reduce(_users, (res, user) => {
        return res + user.fullname + "<br/>";
      },"");
      swal({
        type: "warning",
        title: "Are you sure?",
        text: `you want to reject?<br/>${_names}`,
        html: true,
        showCancelButton: true
      }, () => {
        let _modal = this.$uibModal.open({
          component: "rejectionModal"
        })
        _modal.result.then((rejection) => {
            _.each(_users, (user) => {
              user.rejectionReason = {
                reason: rejection.reason,
                notes: rejection.notes
              }
            })
            this.UserService.reject(_users).$promise.then((saved) => {
              this.loadExOrg();
            })
        })
      })
    }
  }
  public sortBy(usertype:string, type: string) {
    this.sortType[usertype] = type;
    this.reverse[usertype] = !this.reverse[usertype];
  }
  public viewUser(user: any) {
    let _modalInstance = this.$uibModal.open({
      component: "userDetailModal",
      resolve: {
        user: () => {return user}
      }
    })
  }
  public viewActivity(userId: string) {
    let _modelInstance = this.$uibModal.open({
      component: "activityModal",
      resolve: {
        userId: () => {return userId}
      }
    })
  }
  public revoke() {
    let _users = _.filter(this.exOrgRejectUsers, {selected: true});
    if (_users.length) {
      let _names = _.reduce(_users, (res, user) => {
        return res + user.fullname + "<br/>";
      },"");
      swal({
        type: "warning",
        title: "Are you sure?",
        text: `you want to reverse the rejection of<br/>${_names}`,
        html: true,
        showCancelButton: true
      }, () => {
        this.UserService.revoke(_users).$promise.then((saved) => {
          this.loadExOrg();
        })
      })
    }
  }
}
